import { FormControlValidator } from '../use-form-control';
import { RegexValidator } from './regex';

export function NoSpecialCharactersValidator(customMsg?: string): FormControlValidator {
  return RegexValidator(/^[a-zA-Z0-9.+@_ -]*$/, customMsg || 'This field cannot contain special characters');
}
